<template>
    <ModalConsulte ref="modalRef" :hide-footer="true" :hide-header="true" modalWidth="300px !important">
        <template #content>
            <div class="modal-content">
                <div class="modal-body p-4">
                    <div class="text-center">
                        <i class="ri-alert-line h1 text-warning" aria-hidden="true"></i>
                        <h4 class="mt-2">{{ titulo }}</h4>
                        <p class="mt-3" v-html="mensagem"></p>
                        <button type="button" class="btn btn-warning my-2 mx-2" @click="onSim">OK</button>
                    </div>
                </div>
            </div>
        </template>
    </ModalConsulte>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import ModalConsulte from "@/components/modal/ModalConsulte.vue";

export default defineComponent({
    components: {
        ModalConsulte,
    },
    props: {
        titulo: {
            type: String,
            default: 'Atenção!',
        },
        mensagem: {
            type: String,
            default: '',
        },
    },
    emits: ['onSim'],
    setup(props, { emit }) {
        const modalRef = ref();

        const openModal = () => {
            modalRef.value?.open();
        };

        const closeModal = () => {
            modalRef.value?.close();
        };

        const onSim = () => {
            closeModal();
            emit('onSim');
        };

        return {
            modalRef,
            openModal,
            closeModal,
            onSim,
        };
    },
});
</script>
